// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub } from '../pure/unitConversions';

export const convertDataFromServer = (fuelsAct) => ({
  ...fuelsAct,
  sum: convertFromKopToRub(fuelsAct.sum)
});

const fuelsAct = new CommonApi(
  'fuelsAct',
  'акт списания топлива',
  undefined,
  convertDataFromServer
);

export default {
  ...fuelsAct
};
